











































import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
    name: 'NotificationWorkflowIcon',
    props: {
        referenceType: {
            type: String,
            required: false,
        },
        eventType: {
            type: String,
            required: true,
        },
        dropdown: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const iconType = computed(() => {
            switch (props.eventType) {
                case 'workflow.info':
                    return 'neutral';
                case 'workflow.service.completed':
                    return 'success';
                case 'workflow.usedBlockDisabled':
                case 'workflow.triggerConditionLostAccess':
                case 'workflow.service.skipped':
                case 'workflow.service.failed':
                    return 'fail';
                default:
                    return 'neutral';
            }
        });

        return {
            iconType,
        };
    },
});
